import { css } from 'styled-components';
import { getColorShade, getSizeBy } from './utils';
export const BorderTop = css `
  border-top: 1px solid ${getColorShade('onSurface', 'border')};
`;
export const BorderBottom = css `
  border-bottom: 1px solid ${getColorShade('onSurface', 'border')};
`;
export const BorderRight = css `
  border-right: 1px solid ${getColorShade('onSurface', 'border')};
`;
export const BorderLeft = css `
  border-left: 1px solid ${getColorShade('onSurface', 'border')};
`;
const SCROLLBAR_PADDING = 1;
const SCROLLBAR_WIDTH = 1;
export const StyledScrollbarCSS = css `
  /* Firefox */
  * {
    scrollbar-width: auto;
    scrollbar-color: ${getColorShade('onSurface', 'lowEmphasis')} transparent;
  }

  /* Chrome, Edge, Safari */
  *::-webkit-scrollbar {
    width: ${getSizeBy(SCROLLBAR_PADDING * 2 + SCROLLBAR_WIDTH)};
    height: ${getSizeBy(SCROLLBAR_PADDING * 2 + SCROLLBAR_WIDTH)};
  }

  *::-webkit-scrollbar-track,
  *::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    border: solid ${getSizeBy(SCROLLBAR_PADDING)} transparent;
    border-radius: ${getSizeBy(SCROLLBAR_PADDING * 2)};
  }

  *::-webkit-scrollbar-track {
    background-color: ${getColorShade('onSurface', 'outline')};
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${getColorShade('onSurface', 'lowEmphasis')};
  }

  *::-webkit-scrollbar-button {
    display: none;
  }

  *::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;
export const ResetCSS = css `
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
    border: 0;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    line-height: 1;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;
